module.exports = __webpack_public_path__ + "static/img/new_user.40b8051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_user.png
// module id = LSld
// module chunks = 1